import * as React from "react";
import { Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { initializeIcons, Icon } from '@fluentui/react';
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';

interface IQueueNaFilaProps extends WithTranslation {
    botWriting1: boolean;
    appConfigs: any;
    meetingData: any;
    meetingQueueData: any;
    assuntoSelected: string;
    renderAssuntos: any;
    teamsContext: boolean;
    cancelQueue: any;
}

const QueueNaFilaCard: React.FunctionComponent<IQueueNaFilaProps> = props => {
    const localize = props.t;

    initializeIcons();

    return (
        <React.Fragment>
            <Flex gap="gap.medium" className="card" styles={{ margin: "4rem 0" }}>
                <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                <Image hidden={!props.botWriting1} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                <Flex.Item grow>
                    <Segment
                        hidden={props.botWriting1}
                        className="dialog2 dialog"
                        color="brand"
                        content={
                            <Flex gap="gap.large" column>
                                <Text className="header-text" content={localize("VoceEstaNaFila")} />
                                <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                <Flex>
                                    <Flex fill column>
                                        <Label
                                            className="positionLabel"
                                            content={(
                                                <Flex column>
                                                    <Text align="center" className="position" weight="bold" size="largest" content={props.meetingQueueData.queuePosition} />
                                                    <Text align="center" weight="light" size="medium" content={localize("SuaPosicao")} />
                                                </Flex>
                                            )}
                                        />
                                        <Label
                                            className="peopleLabel"
                                            content={(
                                                <Flex column>
                                                    <Text align="center" className="position" styles={{ fontSize: '30px', marginTop: "6px" }} weight="bold" size="largest" content={props.meetingQueueData.queues} />
                                                    <Text weight="light" size="medium" content={localize("PessoasNaFila")} />
                                                </Flex>
                                            )}
                                        />
                                    </Flex>

                                    {props.appConfigs && props.appConfigs.imgQueue != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgQueue} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgQueue == "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/fila.svg" className="filaImg" />
                                        </Flex.Item>
                                    }
                                </Flex>

                                {props.meetingData?.assuntos && props.meetingData?.assuntos?.length > 0 &&
                                    <Flex gap="gap.smaller" column>
                                        <Text weight="bold" size="large" content={localize("AssuntoAtendimentoFila")} />

                                        {props.assuntoSelected == null &&
                                            <React.Fragment>
                                                {/*<Text weight="light" size="medium" content={localize("SelecioneAssunto")} />*/}

                                                <div className="assunto-buttons">
                                                    {props.meetingData.assuntos.map(props.renderAssuntos)}
                                                </div>
                                            </React.Fragment>
                                        }
                                        {props.assuntoSelected != null &&
                                            <Text weight="light" size="medium" content={<React.Fragment><div><span style={{ fontWeight: 'bold' }}>{props.assuntoSelected}</span> {localize("SelecionadoObrigado")}</div></React.Fragment>} />
                                        }

                                    </Flex>
                                }

                            </Flex>
                        }
                    />
                </Flex.Item>
            </Flex>

            {props.meetingData.bookingsUrl &&
                <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting1} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={localize("Agendamento")} />
                                    <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                    <Flex gap="gap.smaller" column>
                                        {props.appConfigs && props.appConfigs.agendamentoQueueText == "" &&
                                            <Text weight="light" size="medium" content={localize("AgendamentoDescricao")} />
                                        }

                                        {props.appConfigs && props.appConfigs.agendamentoQueueText != "" &&
                                            <Text weight="light" size="medium" content={props.appConfigs.agendamentoQueueText} />
                                        }

                                        <Button content={localize("FazerAgendamento")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.meetingData.bookingsUrl), "_blank")} />
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {props.teamsContext &&
                <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting1} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={localize('SairAtendimento')} />
                                    <span className="header-subtext">Para sair e cancelar este atendimento, clique no botão abaixo.</span>

                                    <Button
                                        content={localize("Sair")}
                                        primary
                                        onClick={props.cancelQueue}
                                        icon={<Icon iconName="OutOfOffice" />}
                                    />
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
        </React.Fragment>
    );
};

const queueNaFilaWithTranslation = withTranslation()(QueueNaFilaCard);
export default queueNaFilaWithTranslation;